"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _commonCta = require("@mmc/common-cta");
var _commonRichText = require("@mmc/common-rich-text");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _text = require("@mmc/text");
var _discoverMitsubishi = _interopRequireDefault(require("./discover-mitsubishi.props/discover-mitsubishi.propTypes"));
var _discoverMitsubishi2 = _interopRequireDefault(require("../styles/discover-mitsubishi.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp;
var ctaData = function ctaData(link) {
  var URL = link.URL,
    label = link.label,
    priority = link.priority,
    openNewTab = link.openNewTab,
    icon = link.icon;
  return {
    url: URL,
    label: label,
    priority: priority,
    openNewTab: openNewTab,
    icon: icon
  };
};
var renderCTA = function renderCTA(data, theme, section) {
  if (data) {
    return /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      "data-section": section,
      data: ctaData(data),
      classes: ["" + theme.dark]
    });
  }
  return undefined;
};
var TextBlock = function TextBlock(_ref) {
  var data = _ref.data,
    theme = _ref.theme;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _discoverMitsubishi2["default"].copyContainer
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: handleNestedProp(data, 'data.heading1'),
    className: theme.labelMedium + " " + _discoverMitsubishi2["default"].heading1 + " " + theme.colorWhite,
    tag: "h2",
    disclaimerData: data.disclaimerData
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _discoverMitsubishi2["default"].bottomTextWrapper
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: handleNestedProp(data, 'data.heading2'),
    className: theme.headingThree + " " + theme.colorWhite + " " + theme.marginBottom20,
    tag: "h3",
    disclaimerData: data.disclaimerData
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    theme: theme,
    text: /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
      html: handleNestedProp(data, 'data.textBlock')
    }),
    className: theme.bodyCopy + " " + _discoverMitsubishi2["default"].textBlockParagraph + " " + theme.colorWhite,
    disclaimerData: data.disclaimerData
  }), handleNestedProp(data, 'data.link.URL') && /*#__PURE__*/_react["default"].createElement("div", {
    className: _discoverMitsubishi2["default"].ctaWrapper
  }, renderCTA(handleNestedProp(data, 'data.link'), theme, handleNestedProp(data, 'data.heading2')))));
};
var _default = TextBlock;
exports["default"] = _default;